/* eslint-disable react-hooks/exhaustive-deps */
import { Alert, Box, Button, Card, CardContent, FormControl, InputLabel, MenuItem, Select, TextField, Typography, Container } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../actions/userAction';
import Logo from "../../assets/images/logo/vms-pro-logo.svg";
import { baseUrl } from '../../util/constant';

import AnimatedBackground from './AnimatedBackground';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import React from 'react';
import { persistor } from '../../store/store';
import Progress from '../../components/Loader/Progress ';
import { getAllSettings } from '../../actions/getAllSettings';
import { set } from 'lodash';

function Login() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { success, error , loading } = useSelector((state) => state.user);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [accountType, setAccountType] = useState("admin");
    const settings = useSelector((state) => state.settings);
    const [companyLogoUrl, setCompanyLogoUrl] = useState(null);
    // start with no logo — we'll only show an image if the backend returns one
   

    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(loginUser({ userName, password, accountType }));
    }

    useEffect(() => {
        // Check if there's an account type in the URL search parameters
        const searchParams = new URLSearchParams(window.location.search);
        const accountTypeFromUrl = searchParams.get('accountType');

        // Use the account type from URL if present, otherwise use the one from localStorage
        const initialAccountType = accountTypeFromUrl || localStorage.getItem('accountType') || 'admin';
        localStorage.setItem('accountType', initialAccountType);

        setAccountType(initialAccountType);
    }, []);

    // fetch company logo path from backend and use it if available
    useEffect(() => {
        dispatch(getAllSettings());

    
    }, []);

    useEffect(() => {

        
        if (settings.loading === 'succeeded') {
            setCompanyLogoUrl(settings?.settingsMap?.companyLogoUrl
                ? baseUrl + '/' + settings.settingsMap.companyLogoUrl
                : null);
            

        }

    }, [settings.loading]);

    const onChangeAccountType = (e) => {
        const newAccountType = e.target.value;
        setAccountType(newAccountType);
        localStorage.setItem('accountType', newAccountType);

        // Optional: Update the URL search parameter
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('accountType', newAccountType);
        window.history.replaceState(null, null, "?" + searchParams.toString());
    };

    useEffect(() => {
        if (success)
            navigate('/')
    }, [success])



    return (
        <Box component="div" sx={{ minHeight: '100vh', width: "100%", position: 'relative', overflow: 'hidden' }}>
            {/* Animated background behind all content */}
            <AnimatedBackground style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }} />
            {/* شعار VMS Pro */}
            <Container maxWidth="sm" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', zIndex: 10 }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    gap: 3
                }}>
                    {/* شعار صورة */}
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center',
                        mb: -2, // رفع الشعار للأعلى قليلاً ليقترب من البطاقة
                        mt: 4, // إنزال الشعار قليلاً ليكون بجانب البطاقة
                        position: 'relative',
                        zIndex: 12
                    }}>
                        <img src={Logo} alt='VMS Pro Logo' style={{
                            height: '90px',
                            marginBottom: 0,
                        }} />
                    
                    </Box>


                           {/* Login Card */}

                        {settings.loading === 'pending' || settings.loading === 'idle' ? (
                            <Box sx={{ height: 90, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Progress Msg='please wait' />
                            </Box>
                        ) : (


                    <Card sx={{
                        width: '100%',
                        borderRadius: '16px',
                        background: 'rgba(255,255,255,0.98)',
                        boxShadow: '0 8px 32px 0 rgba(11, 60, 93, 0.10)',
                        overflow: 'hidden',
                        border: '1px solid #e9ecef',
                        transition: 'transform 0.3s, box-shadow 0.3s',
                        '&:hover': {
                            transform: 'translateY(-4px) scale(1.01)',
                            boxShadow: '0 12px 40px 0 rgba(11, 60, 93, 0.18)',
                        }
                    }}>
                        {/* Card Header */}
                        <Box sx={{
                            bgcolor: '#0B3C5D',
                            py: 2,
                            px: 3,
                            textAlign: 'center',
                            borderTopLeftRadius: '16px',
                            borderTopRightRadius: '16px',
                        }}>


                           {settings.loading === 'succeeded' && companyLogoUrl ? (
                                <img src={companyLogoUrl} alt='Company Logo' style={{
                                    height: '90px',
                                    marginBottom: 0,
                                }} /> ) :  (
                                
                                <Typography variant="h6" sx={{ color: '#FFF', fontWeight: 'bold', letterSpacing: 1, fontFamily: 'Arial, sans-serif' }}>
                                Login
                            </Typography>

                                )

                            }


                            
                        </Box>
                        <CardContent sx={{ position: 'relative', minHeight: 220 }}>
                            {/* Overlay loading فقط يغطي CardContent */}
                            {loading && (
                                <Box sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'rgba(255,255,255,0.55)',
                                    zIndex: 20,
                                }}>
                                    <Progress Msg='Loading...' />
                                </Box>
                            )}
                            
                            <Box sx={{ p: { xs: 2, sm: 3 }, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                
                                
                                {/* Account Type Selector */}
                                <FormControl disabled={loading} fullWidth variant="outlined" size="medium" sx={{ mb: 2 }}>
                                    <InputLabel id="account-type-label">Account Type</InputLabel>
                                    <Select
                                        labelId="account-type-label"
                                        id="account-type"
                                        label="Account Type"
                                        value={accountType}
                                        onChange={onChangeAccountType}
                                        startAdornment={
                                            <AccountCircleIcon sx={{ color: '#D9B310', mr: 1 }} />
                                        }
                                    >
                                        <MenuItem value="admin">Administrator</MenuItem>
                                        <MenuItem value="client">Client</MenuItem>
                                    </Select>
                                </FormControl>
                                <form onSubmit={handleLogin} style={{ width: '100%' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        {/* Username Field */}
                                        <TextField
                                        disabled={loading}
                                            label="Username"
                                            variant="outlined"
                                            onChange={(e) => setUserName(e.target.value)}
                                            error={!!error}
                                            fullWidth
                                            margin="normal"
                                            InputProps={{
                                                startAdornment: (
                                                    <PersonIcon sx={{ color: '#0B3C5D', mr: 1 }} />
                                                ),
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#0B3C5D',
                                                    },
                                                },
                                            }}
                                        />
                                        {/* Password Field */}
                                        <TextField
                                        disabled={loading}
                                            type='password'
                                            label="Password"
                                            variant="outlined"
                                            onChange={(e) => setPassword(e.target.value)}
                                            error={!!error}
                                            fullWidth
                                            margin="normal"
                                            InputProps={{
                                                startAdornment: (
                                                    <LockIcon sx={{ color: '#0B3C5D', mr: 1 }} />
                                                ),
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#0B3C5D',
                                                    },
                                                },
                                            }}
                                        />
                                        {/* Error Alert */}
                                        {error && (
                                            <Alert
                                                onClose={() => { persistor.purge() }}
                                                sx={{ margin: "20px 0" }}
                                                variant="filled"
                                                severity="error"
                                            >
                                                Username or password incorrect
                                            </Alert>
                                        )}
                                        {/* Login Button */}
                                        <Button
                                        disabled={loading}
                                            type="submit"
                                            variant="b1"
                                            sx={{
                                                width: '100%',
                                                py: 1.5,
                                                borderRadius: '8px',
                                                fontWeight: 'bold',
                                                textTransform: 'none',
                                                fontSize: '1rem',
                                                background: 'linear-gradient(90deg, #0B3C5D 60%, #D9B310 100%)',
                                                color: '#fff',
                                                boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.10)',
                                                mt: 1,
                                                '&:hover': {
                                                    background: 'linear-gradient(90deg, #0B3C5D 40%, #D9B310 100%)',
                                                    color: '#fff',
                                                    transform: 'scale(1.03)',
                                                    boxShadow: '0 4px 16px 0 rgba(11, 60, 93, 0.18)',
                                                }
                                            }}
                                        >
                                            Login
                                        </Button>
                                    </Box>
                                </form>
                            </Box>
                        </CardContent>
                    </Card>
    )}
                    {/* Footer information below card */}
                    <Typography variant="body2" sx={{
                        color: '#0B3C5D',
                        mt: 2,
                        textAlign: 'center',
                        textShadow: '0 1px 2px rgba(0,0,0,0.08)',
                        fontFamily: 'Arial, sans-serif',
                        fontWeight: 500
                    }}>
                        © {new Date().getFullYear()} <a href="https://pinetechs.com" target="_blank" rel="noopener noreferrer">Pinetechs.com</a>. All rights reserved
                    </Typography>
                </Box>
            </Container>
        </Box>
    )
}

export default Login;